import axios from 'axios'
import store from '../../../../store/store.js'

// const API_URL = 'https://selfie.cash'
const API_URL = 'https://selfie.cash'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

export default {
  init() {
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config

      // if (status === 401) {
      if (response && response.status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch('management/fetchAccessToken')
            .then((access_token) => {
              isAlreadyFetchingAccessToken = false
              onAccessTokenFetched(access_token)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = `Bearer ${access_token}`
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  login(email, pwd) {
    return axios.post(API_URL + '/api/management/login', {
      email,
      password: pwd
    })
  },
  async registerUser(name, userID, dob, organization, department, team, gender, pwd) {

    return await axios.post(API_URL + '/api/management/register', {
      name,
      dob,
      gender,
      userID,
      organization,
      department,
      team,
      password: pwd
    })
  },
  refreshToken() {
    return axios.post(API_URL + '/api/management/refresh-token', { accessToken: localStorage.getItem('accessToKen') })
  }
}
